import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgArrowDownStart = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={32}
    height={25}
    viewBox='0 0 32 25'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M0.646448 21.3536C0.451185 21.1583 0.451185 20.8417 0.646448 20.6464L3.82843 17.4645C4.02369 17.2692 4.34027 17.2692 4.53553 17.4645C4.7308 17.6597 4.7308 17.9763 4.53553 18.1716L1.70711 21L4.53553 23.8284C4.7308 24.0237 4.7308 24.3403 4.53553 24.5355C4.34027 24.7308 4.02369 24.7308 3.82843 24.5355L0.646448 21.3536ZM21.8258 0.5H25V1.5H21.8258V0.5ZM31.5 7V15H30.5V7H31.5ZM25 21.5H1V20.5H25V21.5ZM31.5 15C31.5 18.5899 28.5899 21.5 25 21.5V20.5C28.0376 20.5 30.5 18.0376 30.5 15H31.5ZM25 0.5C28.5899 0.5 31.5 3.41015 31.5 7H30.5C30.5 3.96243 28.0376 1.5 25 1.5V0.5Z'
      fill='#93949A'
    />
  </svg>
);
export default SvgArrowDownStart;
